<template>
  <section class="container-fluid my-4 col-md-10 offset-md-2">
    <h4 class="my-4">Editar <strong>Tipo de Tarefa</strong></h4>

    <form @submit.prevent="handlerSubmit">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="name">Nome</label>
          <input type="text" class="form-control" id="name" v-model="item.name" required />
        </div>
      </div>

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2">SALVAR</button>
      </div>
    </form>

    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">VOLTAR</button>
  </section>
</template>

<script>
import api from "@/services";
import { errorsToString } from "@/helpers";

export default {
  name: "TaskTypeEdit",
  props: ["id"],
  data() {
    return { item: {} };
  },
  methods: {
    async handlerSubmit() {
      try {
        const { data } = await api.put(`/task-types/${this.id}`, this.item);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "task-types" });
      } catch (error) {
        Toast.fire(errorsToString(error.response.data.errors), "", "error");
      }
    },
    async getItem() {
      const { data } = await api.get(`/task-types/${this.id}`);
      this.item = data;
    },
  },
  mounted() {
    this.getItem();
  },
};
</script>
